import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing }) => ({
  container: {
    paddingTop: spacing(16)
  }
}))
